import React, { useRef } from 'react';
import {
  Flex,
  Text,
  VStack,
  Button,
  Box,
  useDisclosure,
  Input,
  Center,
} from '@chakra-ui/react';
import {
  useAppDispatch,
  useAppSelector,
  useCheckMultiplePlatesMutation,
  setFile,
  setMultiple,
} from '@spartalabs/pdc-core';
import { Card, Unauthorized } from 'components';
import { useCustomToast } from 'hooks';
import { DelayAnimation } from 'shared/DelayAnimation';
import { FileModal } from '../Modals/FileModal';
import { NewScheduleHeader } from '../NewScheduleHeader';
import { CustomTable } from '../TableView/components/CustomTable';

export const TableView: React.FC = () => {
  const { permissions, managerId } = useAppSelector(
    state => state.authSlicer.user,
  );

  const multiple = useAppSelector(state => state.scheduleSlicer.multiple);

  const dispatch = useAppDispatch();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { handleToast } = useCustomToast();
  const [checkPlates, { data: sentData, isLoading }] =
    useCheckMultiplePlatesMutation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedFiles = event.target.files;
    if (selectedFiles?.[0]) {
      try {
        const formData = new FormData();

        formData.append('arquivo', selectedFiles[0]);
        formData.append('payload', JSON.stringify({ gestorId: managerId }));

        const multipleData = await checkPlates(formData).unwrap();

        dispatch(setFile(selectedFiles[0]));

        if (multipleData && multipleData?.plates?.length > 0) {
          dispatch(setMultiple(multipleData));

          onOpen();
        } else
          handleToast({
            step: 4,
            action: 'enviar sua planilha',
            helpText: 'Ocorreu um erro inesperado,verifique a planilha enviada',
          });

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (errors: any) {
        handleToast({
          step: 4,
          action: 'enviar sua planilha',
          helpText: 'Ocorreu um erro inesperado,verifique a planilha enviada',
        });

        dispatch(setMultiple(errors));
      }
    }
  };

  if (
    !permissions?.includes('createSchedule') ||
    !permissions?.includes('multiple')
  )
    return <Unauthorized />;

  return (
    <DelayAnimation>
      <NewScheduleHeader step={2} isMultiple />
      <FileModal
        total={sentData?.sentVehicles}
        isOpen={isOpen}
        onClose={onClose}
      />
      <Input
        display="none"
        ref={inputRef}
        cursor="pointer"
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={e => handleFileChange(e)}
      />
      <VStack
        w="100%"
        display="flex"
        align="center"
        justify="center"
        pt="44px"
        pb="44px"
      >
        <Card w="80%" py="16px">
          {multiple?.errors && (
            <Flex
              gap={4}
              flexDir={{ base: 'column', sm: 'row' }}
              w="100%"
              justifyContent="space-between"
              alignItems={{ base: 'start', sm: 'center' }}
            >
              <Box>
                <>
                  <Text fontSize="18px" textColor="text.100">
                    Ocorreu um erro!
                  </Text>
                  <Text fontSize="14px" textColor="text.300">
                    Dos {multiple?.sentVehicles} itens da planilha,{' '}
                    {multiple?.errors?.length}{' '}
                    {multiple?.errors?.length <= 1
                      ? 'está com erro'
                      : 'estão com erros'}
                  </Text>
                </>
              </Box>

              <Button
                isLoading={isLoading}
                onClick={() => inputRef.current?.click()}
                variant="outline"
              >
                Atualizar planilha
              </Button>
            </Flex>
          )}

          <CustomTable data={multiple?.errors} />
          <Center>
            {!multiple?.errors && (
              <Button
                mt="-40px"
                mb="40px"
                isLoading={isLoading}
                onClick={() => inputRef.current?.click()}
                variant="outline"
                width="140px"
              >
                Atualizar planilha
              </Button>
            )}
          </Center>
        </Card>
      </VStack>
    </DelayAnimation>
  );
};
